import { Controller } from "react-hook-form";
import { TextField, TextFieldProps } from "@mui/material";
import { useTranslation } from "react-i18next";

interface FormSelectFieldProps {
    name: string,
    control: any,
    props: TextFieldProps,
    items: any[]
}

export const FormSelect = ({ name, control, props, items }: FormSelectFieldProps) => {

    const { t } = useTranslation('finance');

    return (
            <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) =>
                            <TextField {...props} {...field}
                                       onChange={(e: any)=>{
                                           props.onChange?.(e);
                                           field.onChange(e);
                                       }}
                                       select
                                       error={!!error}
                                       helperText={(error && error.type === 'required' && t('forms.required-field', { label: props.label })) || error?.message}
                            >
                                {items}
                            </TextField>
                    }
            />
    );
}

export default FormSelect;